import React, { useCallback, useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import EventRow from "./event-row/EventRow";
import "./whatsMattersNowCard.scss";
import { SliderAlerts } from "../../../../../../core/api/heroSectionAlertsApi";
import { usePromiseTracker } from "react-promise-tracker";
import AreaLoader from "../../../../../../layout/components/loading/areaLoader";
import { useHistory } from "react-router-dom";
import { viewTrackedItemChart } from "../../../../../../core/helpers/dasboardRoute";
import isActionAllowed from "../../../../../../core/authorization/userPermissions";
import { DASHBOARD_VIEWER, REPORT_CATEGORY_CARE_FINANCIALS, } from "../../../../../../core/constants/permissionConstants";
import NoData from "../../NoData";
import SmilingIcon from "../../../../../../assets/img/slightly-smiling.svg";
import CheckMarkIcon from "../../../../../../assets/img/check-mark.svg";
import IMG_FOOTER_ARROW from "../../../../../../assets/img/arrowSvg.svg";
import { Dropdown, Menu } from "antd";
import { CaretDownFilled } from "@ant-design/icons";
import useDashboardHierarchy from "../../../../../../core/hooks/useDashboardHeirarchy";
import isEmpty from "../../../../../../core/helpers/isEmpty";
function bandLetterFromCurrentBandName(name) {
    if (name === null || name === undefined) {
        return "UNKNOWN";
    }
    const t = name.trim().toUpperCase();
    return t === "A" || t === "B" || t === "C" || t === "D" ? t : "D";
}
function WhatsMattersNowCard(props) {
    var _a;
    const { heading = "What Matters Now!", footerCtaLabel = "View all critical events", className, rootDataNodeId = "1:4759", belowListSlot, stillmatters = false, } = props;
    const [events, setEvents] = useState(null);
    const history = useHistory();
    const isDashboardViewAllowed = isActionAllowed([DASHBOARD_VIEWER]);
    const isFinancialViewAllowed = isActionAllowed([
        REPORT_CATEGORY_CARE_FINANCIALS,
    ]);
    const { isSinglSite, isSingleCompany, isSingleCompanyAndSite, CompanyByGroup, SiteByCompany, } = useDashboardHierarchy();
    const { promiseInProgress } = usePromiseTracker({ area: "slider-alerts" });
    const navigateToDashboardFromAlert = useCallback((row) => {
        if (isEmpty(row.reportId))
            history.push("/vertical/audit-logs");
        else if (row.reportId == null || row.entityId == null)
            return;
        viewTrackedItemChart(+row.reportId, {}, row.entityId, history, CompanyByGroup, SiteByCompany, isSingleCompanyAndSite, isSinglSite, isSingleCompany, isDashboardViewAllowed, isFinancialViewAllowed);
    }, [history, isDashboardViewAllowed, isFinancialViewAllowed]);
    // SORT STATE
    const [selectedSort, setSelectedSort] = useState("Oldest first");
    // Convert dropdown option into API params
    const sortConfig = useMemo(() => {
        switch (selectedSort) {
            case "Oldest first":
                return { sortColumn: "createdDate", sortOrder: "asc" };
            case "Latest first":
                return { sortColumn: "createdDate", sortOrder: "desc" };
            default:
                return { sortColumn: "createdDate", sortOrder: "asc" };
        }
    }, [selectedSort]);
    // Fetch events on sort change
    useEffect(() => {
        stillmatters
            ? SliderAlerts.stillMatterAlerts(1, 6, sortConfig.sortColumn, sortConfig.sortOrder, false, "slider-alerts").then((res) => {
                setEvents(res || null);
            })
            : SliderAlerts.getSliderAlerts(1, 6, sortConfig.sortColumn, sortConfig.sortOrder, false, "slider-alerts").then((res) => {
                setEvents(res || null);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sortConfig.sortColumn, sortConfig.sortOrder]);
    // take only first 6 items
    const displayEvents = ((_a = events === null || events === void 0 ? void 0 : events.content) === null || _a === void 0 ? void 0 : _a.slice(0, 6)) || [];
    const hasEvents = displayEvents.length > 0;
    const rows = useMemo(() => {
        return displayEvents.map((item, index) => ({
            id: String(index + 1),
            title: !isEmpty(item === null || item === void 0 ? void 0 : item.reportId)
                ? item === null || item === void 0 ? void 0 : item.reportName
                : `${item === null || item === void 0 ? void 0 : item.createdUserFirstName} ${item === null || item === void 0 ? void 0 : item.createdUserLastName}` || "",
            subtitle: (item === null || item === void 0 ? void 0 : item.alertText) || "",
            time: (item === null || item === void 0 ? void 0 : item.triggeredAgo) || "",
            status: (item === null || item === void 0 ? void 0 : item.status) || "",
            reportId: item === null || item === void 0 ? void 0 : item.reportId,
            entityId: item === null || item === void 0 ? void 0 : item.entityId,
            severity: bandLetterFromCurrentBandName((item === null || item === void 0 ? void 0 : item.reportId) ? item === null || item === void 0 ? void 0 : item.currentBandName : "D"),
            statusVariant: "text",
        }));
    }, [displayEvents]);
    // subtitle values based on API
    const subheadingStrong = `${(events === null || events === void 0 ? void 0 : events.totalElements) || 0} Events`;
    const subheadingRest = `(Showing Top 6) in the last ${stillmatters ? "35 days" : "24 hrs"}`;
    const menu = (React.createElement(Menu, { onClick: (e) => setSelectedSort(e.key), className: "custom-dropdown-menu" },
        React.createElement(Menu.Item, { key: "Oldest first" }, "Oldest first"),
        React.createElement(Menu.Item, { key: "Latest first" }, "Latest first")));
    return (React.createElement("div", { className: classNames("whats-matters-now-card", className), "data-node-id": rootDataNodeId },
        React.createElement("div", { className: "whats-matters-now-card__header", "data-node-id": "1:4760" },
            React.createElement("div", { className: "whats-matters-now-card__title-block", "data-node-id": "1:4761" },
                React.createElement("p", { className: "whats-matters-now-card__title" }, heading)),
            React.createElement("div", { className: "whats-matters-now-card__subtitle-block", "data-node-id": "1:4762" },
                React.createElement("p", { className: "whats-matters-now-card__subtitle-line" },
                    React.createElement("span", { className: "whats-matters-now-card__subtitle-strong" }, subheadingStrong),
                    React.createElement("span", { className: "whats-matters-now-card__subtitle-rest" }, subheadingRest)))),
        React.createElement("div", { className: "whats-matters-now-card__toolbar-outer", "data-node-id": "1:4763" },
            React.createElement("div", { className: "whats-matters-now-card__toolbar-overlay", "aria-hidden": true }),
            React.createElement("div", { className: "whats-matters-now-card__toolbar-bar", "data-node-id": "1:4764", "data-name": "Control Bar" },
                React.createElement("div", { className: "still-matters-detail__sort-bar" },
                    React.createElement(Dropdown, { overlay: menu, trigger: ["click"] },
                        React.createElement("span", { className: "sort-dropdown" },
                            "Sort by: ",
                            selectedSort,
                            " ",
                            React.createElement(CaretDownFilled, null))))),
            React.createElement("div", { className: "whats-matters-now-card__toolbar-inset-shadow", "aria-hidden": true })),
        React.createElement("div", { className: "whats-matters-now-card__list-wrapper", style: { position: "relative" } },
            promiseInProgress && (React.createElement("div", { className: "whats-matters-now-card__list-loader" },
                React.createElement(AreaLoader, { area: "slider-alerts", customStyle: { display: "block" }, isLandingPage: true }))),
            React.createElement("div", { className: "whats-matters-now-card__list", "data-node-id": "1:4771" }, !promiseInProgress && hasEvents ? (rows.map((row) => (React.createElement("div", { key: row.id, role: "presentation", onClick: () => navigateToDashboardFromAlert(row), style: { cursor: "pointer" } },
                React.createElement(EventRow, { title: row.title, subtitle: row.subtitle, time: row.time, status: row.status, severity: row.severity, iconSrc: row.iconSrc, rimSrc: row.rimSrc, statusVariant: row.statusVariant, daysOpenCount: row.daysOpenCount, className: "whats-matters-now-card__event-row" }))))) : !promiseInProgress ? (React.createElement("div", { className: "whats-matters-now-card__no-data" },
                React.createElement(NoData, { message: rootDataNodeId === "1:4759"
                        ? "No critical issues right now"
                        : "Everything is resolved", detail: rootDataNodeId === "1:4759"
                        ? "Everything is operating within safe limits."
                        : "No ongoing issues require follow-up.", logo: rootDataNodeId === "1:4759" ? SmilingIcon : CheckMarkIcon }))) : null)),
        belowListSlot,
        React.createElement("div", { className: "whats-matters-now-card__footer-margin", "data-node-id": "1:4868" },
            React.createElement("div", { className: "whats-matters-now-card__footer-inner", "data-node-id": "1:4869" },
                React.createElement("button", { type: "button", onClick: () => history.push("/vertical/dashboard"), className: "whats-matters-now-card__footer-cta", "data-node-id": "1:4870", "data-name": "Button" },
                    React.createElement("span", { className: "whats-matters-now-card__footer-cta-text", "data-node-id": "1:4871" }, footerCtaLabel),
                    React.createElement("span", { className: "whats-matters-now-card__footer-cta-icon", "data-node-id": "1:4872" },
                        React.createElement("img", { alt: "", src: IMG_FOOTER_ARROW, className: "whats-matters-now-card__footer-cta-img" })))))));
}
export default WhatsMattersNowCard;
